import { render, staticRenderFns } from "./ChildMenu.vue?vue&type=template&id=6a663ad0&scoped=true&"
import script from "./ChildMenu.vue?vue&type=script&lang=js&"
export * from "./ChildMenu.vue?vue&type=script&lang=js&"
import style0 from "./ChildMenu.vue?vue&type=style&index=0&id=6a663ad0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a663ad0",
  null
  
)

export default component.exports